"use strict";
/**
 *  timeCueModule Module
 *
    Description 策划中心 指挥监测中心 稿件传播力管理 传播力排行榜
 *  Author: gaokaizhi 2018-5-10
 */
angular.module('planCommandMonitorRankingListModule', [])
    .controller('planCommandMonitorRankingListController',["$scope", "$filter", "trsHttpService","planCommandMonitorService",
        function($scope, $filter,trsHttpService,planCommandMonitorService) {
            initData();

            function initData() {
               $scope.params={
                    modalname: "manuScriptsFuncList",
                    method: "getManuScriptslist",
                    methodname: "queryDataFromBigScreen",
                    serviceid: "mlf_bigdatascreen"                   
               };
               $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),$scope.params, "get").then(function(data) {
                $scope.list = data.mapResult.content;
             });
            };
            $scope.scan=function(url){
               window.open(url);
            };

            $scope.share= function(id){
                planCommandMonitorService.share(id,"4","复制链接和密码");
            };

        }
    ]);
